import * as z from "zod/v4";
import { returnsAnalyticsDataQualitySchema } from "./returns-analytics-shared";

export const getReturnsLossReasonsInputSchema = z.object({
  startDate: z.string().min(1).optional(),
  endDate: z.string().min(1).optional(),
});
export type GetReturnsLossReasonsInput = z.infer<
  typeof getReturnsLossReasonsInputSchema
>;

const reasonRowSchema = z.object({
  reason: z.string(),
  dealCount: z.number().int().min(0),
  totalValueCents: z.string(),
});
export type LossReasonRow = z.infer<typeof reasonRowSchema>;

const competitorRowSchema = z.object({
  competitor: z.string(),
  dealCount: z.number().int().min(0),
  totalValueCents: z.string(),
});
export type LossCompetitorRow = z.infer<typeof competitorRowSchema>;

export const getReturnsLossReasonsOutputSchema = z.object({
  totalClosedLost: z.number().int().min(0),
  totalLostValueCents: z.string(),
  byReason: z.array(reasonRowSchema),
  byCompetitor: z.array(competitorRowSchema),
  dataQuality: returnsAnalyticsDataQualitySchema,
});
export type GetReturnsLossReasonsOutput = z.infer<
  typeof getReturnsLossReasonsOutputSchema
>;

export const getReturnsLossReasons = {
  name: "getReturnsLossReasons" as const,
  input: getReturnsLossReasonsInputSchema,
  output: getReturnsLossReasonsOutputSchema,
};
